import axios from "axios";
import { formatApiErrorDetail } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ENQ_API = `${BACKEND_URL}/api/enquiry`;
export const ENQ_TOKEN_KEY = "enq_token";

const enqApi = axios.create({ baseURL: ENQ_API });

enqApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(ENQ_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

enqApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const d = err.response?.data?.detail;
    if (d != null && typeof d !== "string") {
      err.response.data.detail = formatApiErrorDetail(d);
    }
    return Promise.reject(err);
  }
);

export default enqApi;
